import { derivarPeriodo, parseFecha } from "../parseFecha";

// Parser puro del comprobante PDF de LATAM (formato LATAM Perú, USD) -> shape transversal
//   { folio, fecha, periodo, concepto, monto, moneda, unidades }
// Anclas verificadas contra el texto pdfjs real (4 comprobantes) y contra las 13 facturas existentes
// del proveedor 7. Obligatorios (throw): folio, fecha, monto. concepto/unidades null (pasaje puntual,
// no factura por conteo; el hook arma "LATAM AAAA/MM"). periodo derivado de la fecha (día 1 del mes).
//
// DEFENSIVO (P4 / regla 5.16 — "un parser por regex se rompe en SILENCIO si el formato cambia"):
//   - moneda: se LEE el token junto al Total; si no es USD -> throw visible (no se asume USD). Los
//     comprobantes en soles (PEN) u otra moneda NO están soportados todavía -> se avisa, no se falsea.
//   - layout: si falta folio/fecha/monto (formato distinto, ej. LATAM Chile) -> throw, nunca defaults.
//
// Layout pdfjs (Perú): "... Nº de orden   LA5448669CDNU   Ciudad y Fecha de emisión   Lima, Perú
//   25/07/26 Nombre Pasajero ... Número de ticket   Concepto   Monto  0452298041148   Vuelo Tasas
//   y/o impuestos(1) USD 323.00 USD 95.57  Total pagado   USD 418.57 ..."
export const parsearLatamDesdeTexto = (texto) => {
  // folio: el "Nº de orden" (ej. "LA5448669CDNU" = LA + 7 dígitos + 4 letras). Se ancla en "de orden"
  // (NO en la "Nº", cuyo glyph U+00BA es frágil) y se valida el shape estricto. NUNCA el "Número de
  // ticket" (13 dígitos puros, otro campo). Si el token no valida -> throw (formato cambió). Obligatorio.
  const mFolio = texto.match(/de orden\s+(\S+)/);
  const folio = mFolio ? mFolio[1] : null;
  if (!folio || !/^LA\d{7}[A-Z]{4}$/.test(folio))
    throw new Error("No se reconoce el formato de comprobante LATAM (falta Nº de orden)");

  // fecha: "Fecha de emisión   Lima, Perú 25/07/26 Nombre" -> DD/MM/YY. Se saltea la ciudad (Lima,
  // Perú) con el skip no-greedy y se frena en " Nombre" para NO agarrar las fechas del itinerario
  // (ej. "02/08/26"), que aparecen más abajo. parseFecha resuelve DD/MM/YY (rama 6, día-primero).
  // Obligatorio.
  const mFecha = texto.match(/Fecha de emisi[^]*?((?:\d{1,2}\/){2}\d{2})\s+Nombre/);
  const fecha = mFecha ? parseFecha(mFecha[1]) : null;
  if (!fecha) throw new Error("No se pudo leer la fecha de emisión del comprobante LATAM");

  // monto + moneda: "Total pagado   USD 418.57" (total con tasas/impuestos incluidos = lo que se
  // paga). El ancla "Total pagado" evita los parciales previos (USD 323.00 tarifa / USD 95.57 tasas).
  // La moneda se LEE (no se asume): 3 letras junto al monto. Punto decimal; se tolera coma de miles.
  const mTotal = texto.match(/Total pagado\s+([A-Z]{3})\s+([\d,.]+)/);
  if (!mTotal) throw new Error("No se pudo leer el Total pagado del comprobante LATAM");
  const moneda = mTotal[1];
  if (moneda !== "USD") throw new Error(`Comprobante LATAM no-USD (${moneda}), formato no soportado todavía`);
  const monto = Number(mTotal[2].replace(/,/g, ""));
  if (!monto || Number.isNaN(monto)) throw new Error("No se pudo leer el monto del comprobante LATAM");

  return { folio, fecha, periodo: derivarPeriodo(fecha), concepto: null, monto, moneda, unidades: null };
};
